<template>
  <div class="result">
    <img src="../../../assets/img/fullScreen.png" class="fullScreen" @click="toFull" alt="">
    <div class="stu-inner-main">
      <topBanner :title="getPageTitle()"></topBanner>
      <div class="title">
        <div class="cn">恭喜您</div>
        <div class="en">Congratulations!</div>
      </div>
      <div class="title2 title">
        <div class="cn">答题完毕</div>
        <div class="en">Exam finished</div>
      </div>
      <div class="desc">扫描下方二维码关注我们,获取最新赛事资讯</div>
      <div class="descEn">Scan the QR code below to follow us for the latest news.</div>
      <img class="qr" src="https://cdn.spbcn.org/chineseWord/applets/images/mp_qr_en.jpg" alt="">
    </div>
  </div>
</template>
<script>
import topBanner from './topBanner.vue'
export default {
  components: {
    topBanner
  },
  data () {
    return {}
  },
  methods: {
    getPageTitle () {
      return this.$route.query.formName
    },
    toFull () {
      this.$xcUtils.toFull()
    }
  }
}
</script>
<style lang="less" scoped>
.result{
  .title{
    text-align: center;
    color: #000;
    font-family: regular;
    font-size: 32px;
    .en{
      font-size: 18px;
      &::after{
        display: block;
        content: '';
        width: 80px;
        height: 2px;
        background-color: #b81c25;
        margin: 4px auto 20px;
      }
    }
  }
  .title2{
    font-size: 20px;
    .en{
      font-size: 16px;
      &::after{
        display: none
      }
    }
  }
  .desc{
    font-size: 14px;
    margin-top: 30px;
    text-align: center;
  }
  .descEn{
    text-align: center;
    font-size: 14px;
    margin-bottom: 30px;
  }
  .qr{
    width: 180px;
    height: 180px;
    display: block;
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 0 3px 6px 0 rgba(0,0,0,0.15);
  }
}
.stu-inner-main{
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #d8d8d8;
  background-image: url(../../../assets/img/stu-page-bg.png);
  background-size: 100% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
}
.top-banner{
  width: 100%;
  height: 180px;
  background-image: url(../../../assets/img/top-bg.png);
  background-size: cover;
  background-position: center;
  text-align: center;
  line-height: 180px;
  font-size: 30px;
  font-family: regular;
  color: #fff;
  margin-bottom: 20px;
}
.fullScreen{
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 30px;
  height: 30px;
}
</style>
